import { defineStore } from 'pinia'
import axios from 'axios'



export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    user: {
      access_token: localStorage.getItem('access_token') || null
    },
    showDialog: false,
    loading: false,
    your_error_code: false

  }),

  actions: {
    clearUser() {
      this.user.access_token = null;
      this.user.name = null;
      this.user.admin = false;
      localStorage.removeItem('access_token'); // Очищаем localStorage
    },
    openDialogNotAuth() {
      this.showDialog = true;
    },
    closeDialogNotAuth() {
      this.showDialog = false;
    },
    async web_app(data) {
      try {
        const response = await axios.post('/api/web_app', data)
        const res = response.data
        this.user.access_token = res.access_token
        localStorage.setItem('access_token', res.access_token)
        this.user = Object.assign(this.user, res.user)
        return res.user
      } catch (error) {
        return error
      }



    },

    async email_register(data) {
      console.log('Sending registration data:', data)
      const response = await axios.post('/api/email_register', data)
      console.log('Registration response:', response.data)
      const res = response.data
      if (res.email_token) {
        this.user = Object.assign(this.user, data)
        this.user = Object.assign(this.user, res)
        console.log('Updated user state:', this.user)
      }
      return response
    },
    async new_token_email_register(data) {
      const response = await axios.post('/api/new_token_email_register', data)
      const res = response.data
      if (res.email_token) {
        //  localStorage.setItem('access_token', res.access_token)
        this.user = Object.assign(this.user, res)
      }
      return response
    },
    async code_verification_email_register(data) {
      const response = await axios.post('/api/code_verification_email_register', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user = Object.assign(this.user, res.user)
        this.user.access_token = res.access_token
      }
      return response
    },



    async phone_register(data) {
      const response = await axios.post('/api/phone_register', data)
      const res = response.data
      if (res.phone_token) {
        this.user = Object.assign(this.user, data)
        this.user = Object.assign(this.user, res)
      }
      return response

    },
    async code_verification_phone_register(data) {
      const response = await axios.post('/api/code_verification_phone_register', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user = Object.assign(this.user, res.user)
        this.user.access_token = res.access_token
      }
      return response

    },
    async new_token_phone_register(data) {
      const response = await axios.post('/api/new_token_phone_register', data)
      const res = response.data
      if (res.phone_token) {
        //  localStorage.setItem('access_token', res.access_token)
        this.user = Object.assign(this.user, res)
      }
      return response
    },
    async phone_reset_password(data) {
      const response = await axios.post('/api/phone_reset_password', data)
      const res = response.data
      if (res.phone_reset_token) {
        //  localStorage.setItem('access_token', res.access_token)
        this.user = Object.assign(this.user, res)
      }
      return response
    },
    async phone_reset_password_code_check(data) {

      const response = await axios.post('/api/phone_reset_password_code_check', data)
      const res = response.data
      if (res.new_password_token) {
        this.user = Object.assign(this.user, res)
      }
      return response

    },

    async phone_create_new_password(data) {
      if (this.user.new_password_token == null) return
      axios.defaults.headers.common['Authorization'] = "Bearer " + this.user.new_password_token
      const response = await axios.post('/api/phone_create_new_password', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user.access_token = res.access_token
        this.user = Object.assign(this.user, res.user)
      }
      return response

    },



    async auth() {
      try {
        this.loading = true
        if (this.user.access_token == null) return
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.user.access_token
        const response = await axios.get('/api/user')
        const res = response.data
        if (res?.name) {
          this.user = Object.assign(this.user, res)
          return res
        }
        return { Unauthenticated: true }
      } catch (e) {
        this.clearUser()
        return { Unauthenticated: true }
      } finally {
        this.loading = false
      }
    },
    async logout() {
      try {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.user.access_token
        const response = await axios.get('/api/logout')
        const res = response.data
        if (res.logout) {
          localStorage.removeItem('access_token')
          var props = Object.getOwnPropertyNames(this.user);
          for (var i = 0; i < props.length; i++) {
            delete this.user[props[i]];
          }
        }
      } catch (e) {
        console.log(e)
      }
    },

    async login(data) {
      const response = await axios.post('/api/login', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user.access_token = res.access_token
        this.user = Object.assign(this.user, res.user)
        console.log(this.user)
      }
      return response


    },
    async phone_login(data) {


      const response = await axios.post('/api/phone_login', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user.access_token = res.access_token
        this.user = Object.assign(this.user, res.user)
      }
      return response


    },

    async email_reset_password_code_date(data) {

      this.user.email_reset_password_token = null

      const response = await axios.post('/api/email_reset_password_code_date', data)
      const res = response.data
      if (res.email_reset_password_token) {
        this.user = Object.assign(this.user, res)
      }

      return response


    },
    async email_reset_password_code_check(data) {

      const response = await axios.post('/api/email_reset_password_code_check', data)
      const res = response.data
      if (res.new_password_token) {
        this.user = Object.assign(this.user, res)
      }
      return response

    },


    async email_create_new_password(data) {
      if (this.user.new_password_token == null) return
      axios.defaults.headers.common['Authorization'] = "Bearer " + this.user.new_password_token
      const response = await axios.post('/api/email_create_new_password', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user.access_token = res.access_token
        this.user = Object.assign(this.user, res.user)
      }
      return response



    },
    async discord_auth(data) {
      const response = await axios.post('/api/discord_auth', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user.access_token = res.access_token
        this.user = Object.assign(this.user, res.user)
      }
      return response

    },
    async telegram_auth(data) {
      const response = await axios.post('/api/telegram_auth', data)
      const res = response.data
      if (res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        this.user.access_token = res.access_token
        this.user = Object.assign(this.user, res.user)
      }
      return response

    },
    your_error_code_status_true() {
      this.your_error_code = true
    },
    async get_error_user_code() {
      if (this.user.access_token == null) return
      axios.defaults.headers.common['Authorization'] = "Bearer " + this.user.access_token
      const response = await axios.get('/api/get_error_user_code')
      if (response.data?.error_codes_count > 0) {
        this.your_error_code = true

      }
    },

    async update_browser_notifications(enabled) {
      if (this.user.access_token == null) return null
      axios.defaults.headers.common['Authorization'] = "Bearer " + this.user.access_token
      const response = await axios.post('/api/update_browser_notifications', {
        browser_notifications: enabled,
      })
      if (response.data?.success) {
        this.user.browser_notifications = response.data.browser_notifications
      }
      return response.data
    },

  }
})
